import type { UIInventoryItem } from '@sorrem-client/types';
import { resolveHotkeyEquipSlotIndex } from '@sorrem-client/ui/shared/action-bar';
import { toEquipmentSlots, toItemSlotRef } from '@sorrem-client/ui/shared/equipment-slots';
import { useGameplay } from '@sorrem-client/ui/features/PlayPage/gameplay-context';
import { useGameSelector } from '@sorrem-client/ui/hooks';
import { getStoredLoadout } from '@sorrem/shared';
import { useCallback } from 'react';
import { createMoveRequestId } from './use-run-item-transfer';

/** Equips a carried piece of equipment into the first empty valid frame, else swapping out the first valid one. */
export function useEquipCarriedItem(): (itemId: string, equipmentType: NonNullable<UIInventoryItem['equipmentType']>, takesBothHands?: boolean) => void {
    const { bridge, requestInventoryMove } = useGameplay();
    const equipped = useGameSelector(bridge, (state) => getStoredLoadout(state.player));
    return useCallback((itemId, equipmentType, takesBothHands = false): void => {
        const equipSlotIndex = resolveHotkeyEquipSlotIndex(equipmentType, toEquipmentSlots(equipped), takesBothHands);
        if (equipSlotIndex >= 0) {
            void requestInventoryMove(createMoveRequestId(), itemId, toItemSlotRef('equipment', equipSlotIndex));
        }
    }, [equipped, requestInventoryMove]);
}
